"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseSectionName = parseSectionName;
exports.parseArticleData = parseArticleData;
exports.getHeadline = getHeadline;
exports.getSummaryData = getSummaryData;

var _BaobabParagraphs = require("./BaobabParagraphs");

var _ionUtil = require("ion-util");

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function parseSectionName(_x) {
  return _parseSectionName.apply(this, arguments);
}

function _parseSectionName() {
  _parseSectionName = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(label) {
    var name;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            name = label.replace(/\s+- Web\s*$/, '').replace(/^IOL - /, '');
            return _context.abrupt("return", name.toLowerCase().replace(/'/g, '').replace(/-web\s*$/, '').replace(/^iol-/, '').replace(/-+/, '-').replace(/^-+/, '').replace(/-+$/, '').replace(/0027/, ''));

          case 2:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _parseSectionName.apply(this, arguments);
}

function stripCharacters(content) {
  return content.replace(/&#8217;/g, "'").replace(/&#8216;/g, "'").replace(/&#8220;/g, '"').replace(/&#8221;/g, '"').replace(/#0027/g, "'").replace(/&#00238220;/g, "\"").replace(/&#00238221;/g, "\"").replace(/&#00238216;/g, "'").replace(/&#00238217;/g, "'").replace(/&#00238230;/g, ".").replace(/&#0023232;/g, "è").replace(/&#0023233;/g, "é").replace(/&#0023235;/g, "ë").replace(/&#163;/g, "£").replace(/&#232;/g, "è").replace(/&#233;/g, "é").replace(/&#8230;/g, "...").replace(/&#8211;/, "–");
}

function stripHeadline(headline) {
  if (headline) {
    headline = stripTags(headline);
    headline = headline.replace(/\s+/g, ' ');
  }

  return headline;
}

function stripTags(string) {
  if (string) {
    return string.replace(/<(.|\n)*?>/g, '');
  }
}

function parseArticleData(_x2) {
  return _parseArticleData.apply(this, arguments);
}

function _parseArticleData() {
  _parseArticleData = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(content) {
    var article, headline, _abstract, images, videos, youtubes, bodyHTML, paragraphs, relatedArticles, sourceRelatedArticles;

    return regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            article = {};
            article['contentKey'] = content.contentKey;

            if (!content.primarySection) {
              _context4.next = 7;
              break;
            }

            _context4.next = 5;
            return parseSectionName(content.primarySection.replace(/^[^\/]+\//, ''));

          case 5:
            article['section'] = _context4.sent;
            article['titleKey'] = content.primarySection.split(/\//)[0];

          case 7:
            headline = getHeadline(content);
            article['headline'] = stripCharacters(headline);
            _abstract = getAbstract(content);

            if (_abstract) {
              _abstract = stripCharacters(_abstract);
              article['abstract'] = _abstract.replace(/<!--PSTYLE=WL Web Lead-->/, '').replace(/<!--PSTYLE=HEADLINE-->/, '').replace(/<strong>/, '').replace(/<\/strong>/, '').replace(/<!--PSTYLE=hed_35H 30pt-->/, '').replace(/<!--PSTYLE=hed_65H 60pt-->/, '').replace(/<!--PSTYLE=hed_95H 30pt-->/, '').replace(/<!--PSTYLE=hed_95H 72pt-->/, '').replace(/<!--PSTYLE=hed_OPED 48pt-->/, '').replace(/<!--PSTYLE=Normal-->/, '').replace(/<p>/, '').replace(/<\/p>$/, '');
            }

            if (content.byLine) {
              article['author'] = stripTags(content.byLine);
            }

            article['published'] = formatPublished(content.publishDate);
            images = [];
            videos = [];
            youtubes = [];

            if (!content.mediaContainer) {
              _context4.next = 19;
              break;
            }

            _context4.next = 19;
            return Promise.all(content.mediaContainer.mediaLists.map( /*#__PURE__*/function () {
              var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(media) {
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                  while (1) {
                    switch (_context3.prev = _context3.next) {
                      case 0:
                        _context3.next = 2;
                        return Promise.all(media.resources.map( /*#__PURE__*/function () {
                          var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(resource) {
                            var _resource$imageURL$ma, _resource$imageURL$ma2, url, id, videoObject;

                            return regeneratorRuntime.wrap(function _callee2$(_context2) {
                              while (1) {
                                switch (_context2.prev = _context2.next) {
                                  case 0:
                                    if (!(media.mediaType === 'Image' && resource.imageURL)) {
                                      _context2.next = 4;
                                      break;
                                    }

                                    if (resource.imageURL.match('youtube.com')) {
                                      _resource$imageURL$ma = resource.imageURL.match(/youtube\.com\/vi\/(.*)$/), _resource$imageURL$ma2 = _slicedToArray(_resource$imageURL$ma, 2), url = _resource$imageURL$ma2[0], id = _resource$imageURL$ma2[1];
                                      youtubes.push({
                                        url: resource.imageURL,
                                        id: id.replace(/\/default\.jpg/, '')
                                      });
                                    } else {
                                      images.push(translateImageResource(resource));
                                    }

                                    _context2.next = 12;
                                    break;

                                  case 4:
                                    if (!(media.mediaType === 'Video' && resource.url)) {
                                      _context2.next = 11;
                                      break;
                                    }

                                    _context2.next = 7;
                                    return translateVideoResource(resource);

                                  case 7:
                                    videoObject = _context2.sent;
                                    videos.push(videoObject);
                                    _context2.next = 12;
                                    break;

                                  case 11:
                                    console.warn('resource ', content.contentKey, resource);

                                  case 12:
                                  case "end":
                                    return _context2.stop();
                                }
                              }
                            }, _callee2);
                          }));

                          return function (_x9) {
                            return _ref4.apply(this, arguments);
                          };
                        }()));

                      case 2:
                      case "end":
                        return _context3.stop();
                    }
                  }
                }, _callee3);
              }));

              return function (_x8) {
                return _ref3.apply(this, arguments);
              };
            }()));

          case 19:
            if (content.thumbnailURL) {
              images.push({
                url: content.thumbnailURL
              });
            }

            if (!(0, _ionUtil.isEmpty)(images)) {
              article['images'] = images;
            }

            if (videos.length) {
              article['videos'] = videos;
            }

            if (youtubes.length) {
              article['youtubes'] = youtubes;
            }

            bodyHTML = getBodyHTML(content);
            bodyHTML = stripCharacters(bodyHTML);
            article['bodyHTML'] = bodyHTML;
            paragraphs = getParagraphs(bodyHTML);
            _context4.next = 29;
            return getBodyLead(paragraphs);

          case 29:
            article['bodyLead'] = _context4.sent;
            _context4.next = 32;
            return getBodyMore(paragraphs);

          case 32:
            article['bodyMore'] = _context4.sent;
            relatedArticles = [];
            sourceRelatedArticles = content.relatedContent || content.relatedArticles || [];

            if (sourceRelatedArticles.length > 0) {
              sourceRelatedArticles.forEach(function (relatedArticle) {
                if (relatedArticle.externalUrl) {
                  relatedArticles.push(relatedArticle);
                }
              });

              if (relatedArticles.length > 0) {
                article['relatedArticles'] = relatedArticles;
              }
            }

            return _context4.abrupt("return", article);

          case 37:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _parseArticleData.apply(this, arguments);
}

function getAbstract(content) {
  if (content.abstrct) {
    return content.abstrct;
  }

  if (content.summaryAbstract) {
    return content.summaryAbstract;
  }

  if (content.summaryAbstractHTML) {
    return content.summaryAbstractHTML;
  }

  if (content.abstractHTML) {
    return content.abstractHTML;
  }

  if (content["abstract"]) {
    content["abstract"];
  }

  return '';
}

function getHeadline(content) {
  if (content.headline) {
    return stripHeadline(content.headline);
  }

  if (content.summaryHeadline) {
    return stripHeadline(content.summaryHeadline);
  }

  if (content.label) {
    return stripHeadline(content.label);
  }

  return '';
}

function getParagraphs(html) {
  var fromIndex = 0;
  var paragraphs = [];

  while (true) {
    if (html.startsWith('<p')) {
      var index = html.indexOf('</p>');

      if (index < 0) {
        paragraphs.push(html + '</p>');
        return paragraphs;
      }

      index += 4;
      var paragraph = html.substring(fromIndex, index);

      if (paragraph.length) {
        paragraphs.push(paragraph);
      }

      html = html.substring(index);
    } else {
      var _index = html.indexOf('<p');

      if (_index < 0) {
        paragraphs.push(html);
        return paragraphs;
      } else {
        paragraphs.push(html.substring(fromIndex, _index));
        html = html.substring(_index);
      }
    }
  }

  return paragraphs;
}

function checkParagraph(html) {
  if (html.startsWith('<p>')) {
    return html;
  } else {
    var index = html.indexOf('<p>');

    if (index < 0) {
      return '<p>' + html + '</p>';
    } else {
      return '<p>' + html.substring(0, index) + '</p>' + html.substring(index);
    }
  }
}

function translateVideoResource(_x3) {
  return _translateVideoResource.apply(this, arguments);
}

function _translateVideoResource() {
  _translateVideoResource = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(resource) {
    var url, videoMediaSrc, urlToArray;
    return regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            url = resource.url;
            _context5.next = 3;
            return Requests.json({
              url: siteProps.videoServiceUrl + url + '&standAlone=true'
            });

          case 3:
            videoMediaSrc = _context5.sent;
            urlToArray = url.split('/'); //let initialMediaScripts = videoMediaSrc.match(/(<script)(.*)(<\/script>)/)[0]
            //let finalMediaScript = videoMediaSrc.match(/<div id.*([^\n]*\n+)+(.*)/)[0]
            //const videoMediaScript = initialMediaScripts + '\n'+ finalMediaScript

            return _context5.abrupt("return", {
              id: urlToArray[urlToArray.length - 1],
              url: url,
              thumbnailURL: resource.thumbnailURL,
              script: videoMediaSrc
            });

          case 6:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return _translateVideoResource.apply(this, arguments);
}

function translateImageResource(resource) {
  var _ref = resource.imageURL.match(/^.*\/(image|media)\/(.*)$/) || [],
      _ref2 = _slicedToArray(_ref, 3),
      url = _ref2[0],
      type = _ref2[1],
      id = _ref2[2];

  if (!id) {
    throw 'Unsupported image URL: ' + resource.imageURL;
  }

  var image = {
    id: id,
    url: url
  };

  if (resource.caption) {
    image.caption = stripCharacters(resource.caption);
  }

  if (resource.imageWidth) {
    image.width = resource.imageWidth;
    image.height = resource.imageHeight;

    if (false) {
      // TODO
      image.w = resource.imageWidth;
      image.h = resource.imageHeight;
    }

    if (resource.cropWidth) {
      image.crop = {
        w: resource.cropWidth,
        h: resource.cropHeight,
        x: resource.cropOffsetX || 0,
        y: resource.cropOffsetY || 0
      };
    }

    if (resource.focalPointX) {
      image.focalPoint = {
        x: resource.focalPointX,
        y: resource.focalPointY
      };
    }
  }

  return image;
}

function formatPublished(date) {
  if (date) return new Date(date).toISOString().substring(0, 16);else {
    return '';
  }
}

function getBodyHTML(content) {
  if (content.bodyHTML) {
    return content.bodyHTML;
  } else {
    try {
      return concatBodyElementsHtml(content);
    } catch (err) {
      console.warn(err, content.contentKey);
      throw 'body elements: ' + content.contentKey;
    }
  }
}

function getBodyLead(_x4) {
  return _getBodyLead.apply(this, arguments);
}

function _getBodyLead() {
  _getBodyLead = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(paragraphs) {
    var body;
    return regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            body = (0, _BaobabParagraphs.formatHtml)(paragraphs.slice(0, 2));
            _context6.next = 3;
            return reconstructBody(body);

          case 3:
            return _context6.abrupt("return", _context6.sent);

          case 4:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));
  return _getBodyLead.apply(this, arguments);
}

function getBodyMore(_x5) {
  return _getBodyMore.apply(this, arguments);
}

function _getBodyMore() {
  _getBodyMore = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(paragraphs) {
    var body;
    return regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            body = (0, _BaobabParagraphs.formatHtml)(paragraphs.slice(0, 2));
            _context7.next = 3;
            return reconstructBody(body);

          case 3:
            return _context7.abrupt("return", _context7.sent);

          case 4:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));
  return _getBodyMore.apply(this, arguments);
}

function reconstructBody(_x6) {
  return _reconstructBody.apply(this, arguments);
}

function _reconstructBody() {
  _reconstructBody = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(body) {
    var baobabVideoPlaceholderMatch, inlineArticleLinks, inlineAfricanIndyArticleLinks, inlineImageMatch;
    return regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            baobabVideoPlaceholderMatch = /(\[video\]\()(.*)\)/;
            inlineArticleLinks = /href='https?:\/\/([a-z]+\.iol\.co\.za|iol\.co\.za)(.*?)([0-9]{5})/;
            inlineAfricanIndyArticleLinks = /href='https?:\/\/([a-z]+\.africanindy\.com|africanindy\.com)(.*?)([0-9]{5})/;
            inlineImageMatch = /<figure><img class='baobab-embedded-image'/;

            if (!baobabVideoPlaceholderMatch.test(body)) {
              _context8.next = 8;
              break;
            }

            _context8.next = 7;
            return formatBaobabVideo(body);

          case 7:
            body = _context8.sent;

          case 8:
            if (!inlineImageMatch.test(body)) {
              _context8.next = 12;
              break;
            }

            _context8.next = 11;
            return formatInlineImage(body);

          case 11:
            body = _context8.sent;

          case 12:
            return _context8.abrupt("return", body);

          case 13:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  }));
  return _reconstructBody.apply(this, arguments);
}

function concatBodyElementsHtml(content) {
  var html = '';
  var author;

  if (content.byLine) {
    author = content.byLine.replace(/<[^>]*>/g, '');
  }

  assert(content.body && content.body.elements, 'content body elements');
  content.body.elements.forEach(function (element) {
    if (element.content.type === 'html') {
      assert(element.content.html, 'content html');

      if (author && element.content.html.indexOf(author) === 0) {
        html += element.content.html.substring(author.length);
      } else {
        html += element.content.html;
      }
    } else if (element.content.type === 'video-oembed') {
      assert(element.content.oembedContent.html, 'content video-oembed html');
      html += element.content.oembedContent.html;
    } else {
      console.warn('element html empty', content.contentKey, element.type, element);
    }
  });
  return html;
}

function getSummaryData(_x7) {
  return _getSummaryData.apply(this, arguments);
}

function _getSummaryData() {
  _getSummaryData = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(data) {
    var summary;
    return regeneratorRuntime.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            summary = {
              contentKey: data.contentKey,
              section: data.section,
              headline: data.headline,
              "abstract": data["abstract"],
              author: data.author,
              published: data.published,
              titleKey: data.titleKey
            };

            if (!(0, _ionUtil.isEmpty)(data.images)) {
              summary.image = data.images[0];
            }

            if (!(0, _ionUtil.isEmpty)(data.videos)) {
              summary.video = data.videos[0];
            }

            if (!(0, _ionUtil.isEmpty)(data.youtubes)) {
              summary.youtube = data.youtubes[0];
            }

            return _context9.abrupt("return", summary);

          case 5:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9);
  }));
  return _getSummaryData.apply(this, arguments);
}